import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { InvoiceRepository } from '../interfaces/invoice-repository.interface';
import { InvoiceRevenueEditData } from '../models/invoice-revenue-edit.model';

@Injectable()
export class GetInvoiceRevenueEditDataUseCase {
  constructor(private readonly repository: InvoiceRepository) {}

  execute(revenueId: number): Observable<InvoiceRevenueEditData> {
    return this.repository.getRevenueEditData(revenueId);
  }
}

